export default __webpack_public_path__ + "static/slider2-res-970e66d5f59eb3daf8ab0cb245639eea.jpg";